import { Injectable } from '@angular/core';
import { StoreConfig } from '@datorama/akita';
import { DatasourceTableJobStore } from '@y42/datasource';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'ui-modeling-table-job', idKey: 'request_id' })
export class UiModelingTableJobStore extends DatasourceTableJobStore {
  constructor() {
    super();
  }
}
